import { system } from '@workday/canvas-tokens-web'
import { Input } from './Input'

// Stepper outer corners follow the field radius (Canvas shape.md, flag-OFF polyfilled
// to 0.25rem) so the up/down buttons stay flush with the rounded field in both modes.
const stepperRadius = `var(${system.shape.md})`

function getSize(size) {
  const sizeStyle = Input.sizes[size]

  return {
    field: {
      ...sizeStyle.field
    },
    stepper: {
      _first: {
        borderTopEndRadius: stepperRadius
      },
      _last: {
        borderBottomEndRadius: stepperRadius
      }
    }
  }
}

const sizes = {
  xs: getSize('xs'),
  sm: getSize('sm'),
  md: getSize('md'),
  lg: getSize('lg')
}

export const NumberInput = {
  sizes,
  variants: Input.variants,
  defaultProps: Input.defaultProps
}
